import React, { Component } from 'react'
import './style.css'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Glyphicon, FormControl, Row, Col } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import ReactQuill from 'react-quill'

import { changeName, changeTags, changeText, changeDocuments, removeDocument, submitPost, cancelCreation } from './reducers/manageResourcePostCreation'

import AuthenticationComponent from '../../AuthenticationComponent'

import FileUploader from '../../reuseable-components/file-uploading/FileUploader'

class NewResourcePostContainer extends Component {

  createPost = () => {
    let { name, text, tags, documents } = {...this.props}
    let newTags = tags.filter(tag => !tag.hasOwnProperty('created_date'))
    if (newTags.length === 0) {
      newTags = null
    }

    if (newTags) {
      tags = tags.filter(tag => tag.hasOwnProperty('created_date'))
    }

    let post = new FormData()

    post.append("name", name)
    post.append("text", text)
    post.append('tags', JSON.stringify(tags.map(tag => tag.id)))

    if (newTags) {
      post.append('new_tags', JSON.stringify(newTags))
    }

    if (documents.length > 0) {
      documents.forEach((doc, index) => {
        post.append(`document${index}`, doc)
      })
    }

    this.props.submitPost(post, this.props.history)
  }


  render () {
    return (
      <div id="NewResourcePostContainer">
        <AuthenticationComponent />
        <div>
          <Link to="/resource-posts">
            <Button className="back-button" onClick={this.props.cancelCreation}>
              <Glyphicon glyph="arrow-left" /> Cancel
            </Button>
          </Link>
          <Button style={{float:"right"}} onClick={this.createPost} bsStyle="primary">Post</Button>
        </div>
        <Row>
          <Col xs={12} md={6}>
            <FormControl
              defaultValue={this.props.title}
              className="title-form"
              type="text"
              onBlur={(e) => this.props.changeName(e.target.value)}
              placeholder="Enter post title..."/>
          </Col>
          <Col xs={12} md={6}>
            <Typeahead
              id="newResourcePostTags"
              labelKey="name"
              allowNew
              multiple
              defaultSelected={this.props.tags}
              options={this.props.existingTags}
              onChange={(value) => this.props.changeTags(value)}
              className="tag-form"
              placeholder="Input tags..."
            />
          </Col>
        </Row>
        <ReactQuill
          defaultValue={this.props.text}
          theme="snow"
					placeholder="Input content..."
          onChange={(text) => this.props.changeText(text)}
          style={{minHeight:"200px"}}
				/>
        <br/>
        <center>
          <label>Input files</label>
        </center>
        <FileUploader
          allowMultiple={true}
          filesForUpload={this.props.documents}
          handleFileDrop={this.props.changeDocuments}
          removeFile={(document, index) => this.props.removeDocument(index)}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
    existingTags: state.manageResourcePosts.tags,
    name: state.manageResourcePostCreation.name,
    tags: state.manageResourcePostCreation.tags,
    text: state.manageResourcePostCreation.text,
    documents: state.manageResourcePostCreation.documents,
  }
}

export default connect(mapStateToProps, { changeName, changeTags, changeText, changeDocuments, removeDocument, submitPost, cancelCreation })(NewResourcePostContainer);



// WEBPACK FOOTER //
// ./src/routes/resource-posts_new/NewResourcePostContainer.js